import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const GoalDisplaySkeleton: FC = () => {
    return (
        <Stack direction="row" alignItems="center" gap={0.8}>
            <ThemedSkeleton variant="circular" colorVariant="secondary" width={30} height={30} />
            <Stack alignItems="center" gap={0.1}>
                <ThemedSkeleton variant="text" colorVariant="secondary" width={12} height={17} />
                <ThemedSkeleton variant="text" colorVariant="secondary" width={12} height={1} />
                <ThemedSkeleton variant="text" colorVariant="secondary" width={12} height={17} />
            </Stack>
        </Stack>
    );
};

